import React, { useEffect, useState } from 'react';
import DragAndDrop from '../../NewPatient/Photos/DragAndDrop';
import { useFormContext } from 'react-hook-form';
import style from './uploadPhotoRhf.module.css';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { Button } from '@material-ui/core';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import { ErrorMessage } from '@hookform/error-message';

const UploadPhotoRhf = ({ name, defaultValue = null, label, readOnly = false }) => {
    const {
        formState: { errors, isSubmitting, isValid, defaultValues },
        setValue,
        setError,
        clearErrors,
        getValues,
    } = useFormContext();
    const [photoData, setPhotoData] = useState(defaultValue);
    const [photoFileData, setPhotoFileData] = useState(defaultValue);
    const [rotate, setRotate] = useState(0);

    const handleDragAndDrop = (event) => {
        let file = event;
        // console.log('handleDragAndDrop file: ', file);
        if (file) {
            setPhotoData(URL.createObjectURL(file));
            setPhotoFileData(file);
        }
    };

    const handleDrop = (event) => {
        let file = event.target.files[0];
        // console.log('handleDrop file: ', file);
        file && setPhotoData(URL.createObjectURL(file));
        file && setPhotoFileData(file);
    };

    const removefile = () => {
        setRotate(0);
        setPhotoData(null);
        setPhotoFileData(null);
    };

    const handleRotate = (direction) => {
        switch (direction) {
            case 'rotateRight': {
                setRotate(rotate + 90);
                // saveRotate()
                break;
            }
            case 'rotateLeft': {
                setRotate(rotate - 90);
                // saveRotate(-90)
            }
        }
    };

    useEffect(() => {
        setValue(name, photoFileData);
        if (photoData !== null) {
            clearErrors(name);
        }
    }, [photoData, photoFileData]);

    useEffect(() => {
        if (getValues(name) === null && ((isSubmitting && photoData === null) || (!isValid && photoData === null))) {
            setError(name, {
                type: 'required',
                message: 'Required',
            });
        }
    }, [isSubmitting, isValid, photoData]);

    useEffect(() => {
        if (getValues(name) && readOnly) {
            setPhotoData(getValues(name)); //Explain: set default value
        }
    }, [defaultValues, readOnly]);

    return (
        <div style={{ width: '100%' }}>
            <>
                {!photoData && !readOnly ? (
                    <DragAndDrop handleDrop={handleDragAndDrop}>
                        <div className={style.imageUploadArea} style={{ height: '426px' }}>
                            <span>{label}</span>
                            <div className={style.uploadBtnWrapper}>
                                <button className={style.uploadBtn}>+</button>
                                <input type="file" onChange={handleDrop} accept="image/*" name={name} id={name} />
                            </div>
                        </div>
                    </DragAndDrop>
                ) : (
                    <DragAndDrop handleDrop={handleDragAndDrop}>
                        <div className={style.imageUploadArea}>
                            <span
                                style={{
                                    position: 'absolute',
                                    color: 'black',
                                    fontSize: 16,
                                    top: 0,
                                    fontWeight: 'bold',
                                    left: '50%',
                                    transform: 'translate(-50%)',
                                }}
                            >
                                {label}
                            </span>
                            {/* <img style={{ width: "100%", maxWidth: 400, marginTop: "7%", transform: `rotateZ(0}deg)` }} src={photoData} /> */}
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '426px',
                                }}
                            >
                                <img
                                    style={{
                                        width: '100%',
                                        maxWidth: 400,
                                        marginTop: '7%',
                                        transform: `rotateZ(${rotate}deg)`,
                                    }}
                                    src={photoData}
                                />
                                {/* <img style={{ width: "100%", maxWidth: 400, marginTop: "7%" }} src={photoData} /> */}
                            </div>
                            {!readOnly && (
                                <button className={style.remove} onClick={removefile}>
                                    <DeleteOutlinedIcon />
                                </button>
                            )}
                        </div>

                        {/* <div className={style.uploadFooter}>
                                <Button style={{ marginLeft: 15 }} variant="outlined" className={style.customButton} value="rotateLeft" onClick={() => handleRotate("rotateLeft")}><RotateLeftIcon /></Button>
                                <Button style={{ marginLeft: 15 }} variant="outlined" className={style.customButton} value="rotateRight" onClick={() => handleRotate("rotateRight")}><RotateRightIcon /></Button>
                            </div> */}
                    </DragAndDrop>
                )}
                <div style={{ marginBottom: 12 }}>
                    <ErrorMessage
                        errors={errors}
                        name={name}
                        render={({ message }) => <div style={{ color: 'red' }}>{message}</div>}
                    />
                </div>
            </>
        </div>
    );
};

export default UploadPhotoRhf;
